import type { BunkerScene } from './BunkerScene';

// Holds a reference to the active BunkerScene so React-side code (drop targets,
// animations triggered from outside Phaser) can call methods on it without
// reaching through Phaser's game tree each time.
let sceneRef: BunkerScene | null = null;

export function setBunkerSceneRef(s: BunkerScene | null): void {
  sceneRef = s;
}

export function getBunkerSceneRef(): BunkerScene | null {
  return sceneRef;
}
